const parseValue = (value) => {
  if (value === 'true') {
    return true;
  }
  if (value === 'false') {
    return false;
  }
  const trimmed = value.trim();
  if (
    (trimmed.startsWith('"') && trimmed.endsWith('"')) ||
    (trimmed.startsWith("'") && trimmed.endsWith("'"))
  ) {
    return trimmed.slice(1, -1);
  }
  return trimmed;
};

const parseFrontmatter = (text) => {
  const lines = text.split('\n');
  if (lines[0]?.trim() !== '---') {
    return { frontmatter: {}, body: text };
  }

  const frontmatter = {};
  let currentParent = null;
  let index = 1;

  for (; index < lines.length; index += 1) {
    const line = lines[index];
    if (line.trim() === '---') {
      index += 1;
      break;
    }
    if (!line.trim()) {
      continue;
    }

    if (line.startsWith('  ') && currentParent) {
      const childLine = line.trim();
      if (childLine.startsWith('- ')) {
        if (!Array.isArray(frontmatter[currentParent])) {
          frontmatter[currentParent] = [];
        }
        frontmatter[currentParent].push(parseValue(childLine.slice(2)));
        continue;
      }
      if (childLine.includes(':')) {
        const [childKey, ...rest] = childLine.split(':');
        if (!frontmatter[currentParent] || Array.isArray(frontmatter[currentParent])) {
          frontmatter[currentParent] = {};
        }
        frontmatter[currentParent][childKey.trim()] = parseValue(rest.join(':'));
        continue;
      }
    }

    const [key, ...rest] = line.trim().split(':');
    const value = rest.join(':').trim();
    if (value) {
      frontmatter[key.trim()] = parseValue(value);
      currentParent = null;
    } else {
      currentParent = key.trim();
    }
  }

  return {
    frontmatter,
    body: lines.slice(index).join('\n').trim(),
  };
};

const context = require.context('./', false, /\.md$/);
const assetContext = require.context('./', false, /\.(png|jpe?g|webp|gif|svg)$/);
const publicationFiles = context
  .keys()
  .filter((filename) => !filename.includes('template') && !filename.includes('README'));

const resolveAsset = (value) => {
  if (!value || typeof value !== 'string') {
    return value;
  }
  if (value.startsWith('/')) {
    return value;
  }
  const normalized = value.startsWith('./') ? value : `./${value}`;
  if (assetContext.keys().includes(normalized)) {
    return assetContext(normalized);
  }
  return value;
};

export const loadPublications = async () => {
  const items = await Promise.all(
    publicationFiles.map(async (filename) => {
      const url = context(filename);
      const response = await fetch(url);
      const text = await response.text();
      const { frontmatter, body } = parseFrontmatter(text);

      return {
        ...frontmatter,
        heroImage: resolveAsset(frontmatter.heroImage),
        seo: frontmatter.seo
          ? {
              ...frontmatter.seo,
              image: resolveAsset(frontmatter.seo.image),
            }
          : undefined,
        body,
        source: filename.replace('./', ''),
      };
    }),
  );

  return items;
};
